import { HStack, Heading, VStack, Stack } from '@chakra-ui/react';
import PageHeader from '../../components/PageHeader/PageHeader';
import NetworkSelect from '../../components/Select/NetworkSelect/NetworkSelect';
import PageLayout from '../../components/layout/PageLayout';

import useIsMobile from '../../hooks/useIsMobile';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LiquidityControls from './components/LiquidityControls';
import PoolList from './components/PoolList';

const Liquidity: React.FC = () => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    useEffect(() => {
        document.title = t('Liquidity') + ' | iZUMi.finance';
    }, [t]);
    return isMobile ? (
        <PageLayout
            body={
                <Stack w="100%" spacing="30px">
                    <LiquidityControls />
                    <PoolList />;
                </Stack>
            }
            type="mobile"
        />
    ) : (
        <PageLayout
            header={
                <PageHeader
                    headerTitle={
                        <HStack spacing="20px">
                            <Heading level="3" fontSize={'24px'}>
                                {'Liquidity'}
                            </Heading>
                        </HStack>
                    }
                    subtitle={'Manage liquidity.'}
                    element={
                        <HStack spacing="10px">
                            <NetworkSelect />
                        </HStack>
                    }
                />
            }
            body={
                <VStack>
                    <LiquidityControls />
                    <PoolList />
                </VStack>
            }
        />
    );
};
export default Liquidity;
